module.exports = __webpack_public_path__ + "static/media/NO_SMALL_ANIMALS.7e941052.svg";